import React from "react";
import { fmtMoney } from "@/lib/api";

export const InvoiceTotals = ({ invoice, theme, themeName, brand }) => (
  <div className="mt-6 space-y-1 text-right font-mono text-sm">
    <div className={theme.muted}>Subtotal: {fmtMoney(invoice.subtotal, invoice.currency)}</div>
    <div className={theme.muted}>Tax: {fmtMoney(invoice.tax_amount, invoice.currency)}</div>
    {themeName === "modernist" ? (
      <div
        className="mt-3 inline-block px-5 py-3 text-white"
        style={{ background: brand }}
        data-testid="public-invoice-total"
      >
        <span className="text-[10px] uppercase tracking-[0.28em] font-bold mr-3 opacity-80">Total due</span>
        <span className="text-2xl font-black">{fmtMoney(invoice.total, invoice.currency)}</span>
      </div>
    ) : (
      <div
        className={`${theme.totalCls} mt-3`}
        style={themeName === "atelier" || themeName === "manuscript" ? { color: brand } : undefined}
        data-testid="public-invoice-total"
      >
        {fmtMoney(invoice.total, invoice.currency)}
      </div>
    )}
  </div>
);
